module.exports = __webpack_public_path__ + "static/media/markus-dyer-quote.55041a8e.png";